<template>
  <div class="modal" v-bind:class="{ 'is-active': showModal }">
    <div class="modal-background" v-on:click="closeModal"></div>
    <div class="modal-content">
      <form v-on:submit.prevent="search">
        <div class="columns">
          <div class="column">
            <div class="label">Nombre</div>
            <input
              type="numeric"
              class="input"
              placeholder="Nombre"
              v-model="name"
              @focus="focus('name')"
            />
          </div>
          <div class="column">
            <div class="label">ID</div>
            <input
              type="numeric"
              class="input"
              placeholder="ID"
              v-model="id"
              @focus="focus('id')"
            />
          </div>
          <div class="column">
            <div class="label">Dorsal</div>
            <input
              type="numeric"
              class="input"
              placeholder="Dorsal"
              v-model="number"
              @focus="focus('number')"
            />
          </div>
        </div>

        <div class="zcolumns">
          <div class="zcolumn" v-if="searchListsTShirt">
            <div class="tag-cont">
              <div class="label">
                {{ searchListsTShirt.text }}
              </div>
              <div class="columns is-multiline">
                <div
                  class="column is-3"
                  v-for="value in searchListsTShirt.values"
                  v-bind:key="value.code"
                >
                  <button
                    type="button"
                    class="add-field add-value button"
                    v-bind:class="{
                      'is-light':
                        selectedList != searchListsTShirt.code ||
                        selectedListValue != value.code,
                      'is-primary':
                        selectedList == searchListsTShirt.code &&
                        selectedListValue == value.code,
                    }"
                    v-on:click="addField(searchListsTShirt, value)"
                  >
                    {{ value.text }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="zcolumn"
            v-if="searchListsOther && searchListsOther.length > 0"
          >
            <div
              class="tag-cont"
              v-for="list in searchListsOther"
              v-bind:key="list.code"
            >
              <div class="label">
                {{ list.text }}
              </div>
              <div class="columns is-multiline">
                <div
                  class="column is-3"
                  v-for="value in list.values"
                  v-bind:key="value.code"
                >
                  <button
                    type="button"
                    class="add-field add-value button"
                    v-bind:class="{
                      'is-light':
                        selectedList != list.code ||
                        selectedListValue != value.code,
                      'is-primary':
                        selectedList == list.code &&
                        selectedListValue == value.code,
                    }"
                    v-on:click="addField(list, value)"
                  >
                    {{ value.text }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button type="submit" class="add button submit-button is-warning">
          Buscar
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../services/event-bus.js";
import firebase from "firebase";
const fb = require("../firebase");
const storage = firebase.storage();

export default {
  props: {},
  components: {},
  computed: {
    searchListsTShirt() {
      if (!this.gallery || !this.gallery.searchLists) {
        return [];
      }
      const list = this.gallery.searchLists.find(
        (l) => l.code == "color-tshirt"
      );
      return list ? list : [];
    },
    searchListsPants() {
      if (!this.gallery || !this.gallery.searchLists) {
        return [];
      }
      const list = this.gallery.searchLists.find(
        (l) => l.code == "color-pants"
      );
      return list ? list : [];
    },
    searchListsOther() {
      if (!this.gallery || !this.gallery.searchLists) {
        return [];
      }
      const list = this.gallery.searchLists.filter(
        (l) => l.code !== "color-tshirt" && l.code !== "color-pants"
      );
      return list ? list : [];
    },
  },
  async created() {
    EventBus.$on("search-popup", async (popupInfo) => {
      await this.initialize();
      this.gallery = popupInfo.gallery;
      this.showModal = true;
    });
  },
  data() {
    return {
      showModal: false,
      name: "",
      id: "",
      number: "",
      gallery: {},
      selectedList: "",
      selectedListValue: "",
    };
  },
  methods: {
    closeModal() {
      this.showModal = false;
      this.$emit("close", {});
    },
    async initialize() {},
    search() {
      this.$emit("search", {
        name: this.name,
        id: this.id,
        number: this.number,
        list: this.selectedList
          ? `${this.selectedList}:${this.selectedListValue}`
          : "",
      });
      this.showModal = false;
    },
    addField(list, value) {
      this.selectedList = list.code;
      this.selectedListValue = value.code;
    },
    focus(field) {
      this.selectedList = "";
      this.selectedListValue = "";
      if (field == "name") {
        this.id = "";
        this.number = "";
      }
      if (field == "id") {
        this.name = "";
        this.number = "";
      }
      if (field == "number") {
        this.id = "";
        this.name = "";
      }
    },
  },
};
</script>
<style scoped>
.modal-content {
  max-width: auto;
  min-width: 50vw;
}
.label {
  margin-top: 1rem;
}
.submit-button {
  margin-top: 2rem;
}
.input {
  margin-bottom: 0;
}
</style>
